
export default function useUserRole(user: any) {
    return {
        isAdmin: user.roles?.includes('admin') || false,
        isReviewer: user.roles?.includes('reviewer') || false,
        isLeader: user.roles?.includes('leader') || false,
        isApprover: user.roles?.includes('approver') || false,
        canSeePulse: user.pulse_enabled || user.roles?.includes('admin') || false,
        hasRole: (role: string) => user.roles?.includes(role) || false
    }
}
